export const EXSBREASON_SHOW_RESET = 'EXSBREASON_SHOW_RESET'
export const EXSBREASON_SHOW_SET_ERROR = 'EXSBREASON_SHOW_SET_ERROR'
export const EXSBREASON_SHOW_SET_RETRIEVED = 'EXSBREASON_SHOW_SET_RETRIEVED'
export const EXSBREASON_SHOW_TOGGLE_LOADING = 'EXSBREASON_SHOW_TOGGLE_LOADING'
